import { NgModule } from '@angular/core';
import { SvgIconComponent } from '@shared/components/svg/svg-icon.component';

@NgModule({
  declarations: [SvgIconComponent],
  exports: [SvgIconComponent]
})
export class SvgModule {}
